import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { UploadOtpService } from '../pages/otp/services/upload-otp.service';
import { map } from 'rxjs';

export const OtpUploadGuard = () => {
  const router = inject(Router);
  const uploadOtpService = inject(UploadOtpService);
  const id = localStorage.getItem('otp-id');
  if (!id) {
    router.navigate(['otp/logout']);
    return false;
  }
  return uploadOtpService.validateCode().pipe(
    map((res) => {
      if (!res) {
        localStorage.removeItem('otp-id');
        router.navigate(['otp/logout']);
      }
      return res;
    })
  );
};
